import React from "react";
import Layout from "./src/components/Layout";
import { reportClientError } from "./src/utils/clientErrorReporter";
import { initSessionTracking, recordPreviousPage } from "./src/utils/formTracking";
import "./src/index.css";
import { recoverSelection, listenForJourneyRequests } from "./src/utils/journeyState";
import { safePageParameters, scrubLegacyMatchingUrl } from "./src/utils/analyticsPrivacy";

export const wrapPageElement = ({ element, props }) => {
  return <Layout location={props?.location}>{element}</Layout>;
};

// Track page views on route change and persist session attribution context.
export const onRouteUpdate = ({ location, prevLocation }) => {
  scrubLegacyMatchingUrl();
  recoverSelection(location.search);
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', safePageParameters(location, prevLocation?.pathname || document.referrer));
  }

  // Persist landing page + UTM params (first call sets landing page once).
  initSessionTracking(location);

  // Store the previous page path so GetStartedPage can infer clinician or
  // service context (e.g. user navigated from /our-clinicians/cameron-eshgh).
  if (prevLocation?.pathname) {
    recordPreviousPage(prevLocation.pathname);
  }
};

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;
  listenForJourneyRequests();

  window.addEventListener('error', (event) => {
    reportClientError(event?.error || event?.message, {
      scope: 'window-error',
      fatal: true,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportClientError(event?.reason || 'Unhandled promise rejection', {
      scope: 'unhandled-rejection',
      fatal: false,
    });
  });
};
